__webpack_require__.p = "/dist/hbt-internal-portal/";